import {getJWT} from "../../utils/storageService";
import {useQuery} from "@tanstack/react-query";
import axios from "axios";
import {Change} from "../interfaces/Change";
import {links} from "../../utils/links";


const useClientChangesQuery = () => {

    const jwt = getJWT();
    const headers = {Authorization: `Bearer ${jwt}`}

    return useQuery({
        queryKey: ["Client", "Changes"],
        queryFn: () => axios
            .get<Change[]>(links.getAenderungen, {headers})
            .then(res => res.data.filter(change => change.status === "P"))
            .catch(err => console.log(err))
    })
}

export default useClientChangesQuery;